import * as React from "react";
import {IInformProps} from "../../../model/inform/InformProduct";
import {RelativePerformanceChart} from "../../inform/RelativePerformanceChart";
import {PerformanceComponent} from "../../inform/PerformanceComponent";
import {IInformPerformance} from "../../../model/inform/InformPerformance";
import {useState} from "react";


export interface IProductPerformanceAnalyticsProps {
    informProduct: IInformProps
}

export const PRODUCT_PERFORMANCE_DISCLOSURE_TEXT = "Source: eVestment Alliance (“eVestment”), an institutional investment database. eVestment is an independent third-party and is not related to Aon. Aon has no control over and does not endorse or have responsibility for any content or information provided on the eVestment database. Performance information reported by eVestment is based on self-reported gross-of-fee returns, as manager fees may vary. Investment management fees and other investment related expenses would reduce performance. Self-reported returns may be the performance of a composite (aggregation of one or more portfolios) or pooled investment vehicle (e.g., mutual fund, exchange-traded fund, collective investment trust, etc.). Fees and expenses may also vary among separately managed accounts and pooled investment vehicles. Aon pays a fee to eVestment for access to performance and analytical services. Past performance is not indicative of future results. As with any investment, there is potential for profit as well as the possibility of loss.";

export const ProductPerformanceAnalytics: React.FunctionComponent<IProductPerformanceAnalyticsProps> = (props) => {
    const [disclosureOpen, setDisclosureOpen] = useState<boolean>(false);
    const renderRelativePerformanceChart = () => {
        return props.informProduct?.summary?.relativePerformance?.length
            ? <RelativePerformanceChart
                relativePerformance={props.informProduct.summary.relativePerformance}
                effectiveDate={props.informProduct.summary?.ifaRatingEffectiveDate ? props.informProduct.summary.ifaRatingEffectiveDate : ""}
                informBenchmark={props.informProduct.summary.inFormBenchmark}/>
            : null;
    };

    const renderCumulativeAbsoluteReturnChartWithPeriods = () => {
        return props.informProduct?.performance
            ? <PerformanceComponent {...props.informProduct.performance as IInformPerformance}/>
            : null;
    };

    const renderDisclosureText = () => {
        return <div className={"product-performance-tab__disclosure-text"}
                    data-testid="product-performance-tab__disclosure-text">
            {PRODUCT_PERFORMANCE_DISCLOSURE_TEXT}
        </div>;
    };

    const renderDisclosure = () => {
        return <div className={"product-performance-tab__disclosure-container"}>
          <span className="product-performance-tab__disclosure-toggle clickable link-16"
                data-testid="product-performance-tab__disclosure-toggle"
                onClick={() => setDisclosureOpen(!disclosureOpen)}>
                    Disclosure
                    <span className={disclosureOpen ? "fal fa-angle-up" : "fal fa-angle-down"}
                          data-testid={"product-performance-tab__disclosure-icon"}/>
            </span>
            {disclosureOpen && renderDisclosureText()}
        </div>;
    };

    return <div className="product-performance-analytics__container"
                data-testid="product-performance-analytics__container">
        {renderRelativePerformanceChart()}
        {renderCumulativeAbsoluteReturnChartWithPeriods()}
        {renderDisclosure()}
    </div>;
};